// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__mLkGN","image":"Modal_image__GjWp9","closeIconContainer":"Modal_closeIconContainer__e2rVE","closeIcon":"Modal_closeIcon__r3--D"};